export default {
    queryInsuranceList: [
        {
            insNo: '1234QWER567890',
            insCode: 'f3a0796e-4d4f-4666-99af-06fdf01956e8',
            insuranceStatus: null,
            supplier: '磊山保經',
            supplierCode: null,
            productName: '圓滿人生終身壽險',
            allProductsName: ['圓滿人生終身壽險', '新住院醫療保險附約'],
            payerName: '林小磊',
            payerCode: '123123',
            insuredName: ['林小磊'],
            insuredCode: '123123',
            salesName: null,
            effectDate: '2013/03/01',
            createdDate: '2025-07-17 09:37:15.705',
            creatorName: '林小磊',
            remark: null,
            insType: null,
            sourceType: 1,
            updateDate: '2025-07-17 09:32:09'
        },
        {
            insNo: '1234QWER567890-01',
            insCode: '6b12ee4f-48e3-4270-8f86-dbbb6c2ca275',
            insuranceStatus: null,
            supplier: '磊山保經',
            supplierCode: null,
            productName: '圓滿人生終身壽險',
            allProductsName: ['圓滿人生終身壽險', '新住院醫療保險附約'],
            payerName: '林小磊',
            payerCode: '123123',
            insuredName: ['林小磊'],
            insuredCode: '123123',
            salesName: null,
            effectDate: '2013/03/01',
            createdDate: '2025-07-17 09:37:15.705',
            creatorName: '林小磊',
            remark: null,
            insType: null,
            sourceType: 1,
            updateDate: '2025-07-17 09:32:09'
        },
        {
            insNo: '1234QWER567890-02',
            insCode: '876ef59f-e981-41a7-a0a0-bafc0beeac3a',
            insuranceStatus: null,
            supplier: '磊山保經',
            supplierCode: null,
            productName: '圓滿人生終身壽險',
            allProductsName: ['圓滿人生終身壽險', '新住院醫療保險附約'],
            payerName: '林小磊',
            payerCode: '123123',
            insuredName: ['林小磊'],
            insuredCode: '123123',
            salesName: null,
            effectDate: '2013/03/01',
            createdDate: '2025-07-17 09:37:15.705',
            creatorName: '林小磊',
            remark: null,
            insType: null,
            sourceType: 1,
            updateDate: '2025-07-17 09:32:09'
        },
        {
            insNo: '1234QWER567890',
            insCode: 'f3a0796e-4d4f-4666-99af-06fdf01956e8',
            insuranceStatus: null,
            supplier: '磊山保經',
            supplierCode: null,
            productName: '圓滿人生終身壽險',
            allProductsName: ['圓滿人生終身壽險', '新住院醫療保險附約'],
            payerName: '林小磊',
            payerCode: '123123',
            insuredName: ['林小磊'],
            insuredCode: '123123',
            salesName: null,
            effectDate: '2013/03/01',
            createdDate: '2025-07-17 09:37:15.705',
            creatorName: '林小磊',
            remark: null,
            insType: null,
            sourceType: 3,
            updateDate: '2025-07-17 09:32:09'
        },
        {
            insNo: '1234QWER567890-01',
            insCode: '6b12ee4f-48e3-4270-8f86-dbbb6c2ca275',
            insuranceStatus: null,
            supplier: '磊山保經',
            supplierCode: null,
            productName: '圓滿人生終身壽險',
            allProductsName: ['圓滿人生終身壽險', '新住院醫療保險附約'],
            payerName: '林小磊',
            payerCode: '123123',
            insuredName: ['林小磊'],
            insuredCode: '123123',
            salesName: null,
            effectDate: '2013/03/01',
            createdDate: '2025-07-17 09:37:15.705',
            creatorName: '林小磊',
            remark: null,
            insType: null,
            sourceType: 3,
            updateDate: '2025-07-17 09:32:09'
        },
        {
            insNo: '1234QWER567890-02',
            insCode: '876ef59f-e981-41a7-a0a0-bafc0beeac3a',
            insuranceStatus: null,
            supplier: '磊山保經',
            supplierCode: null,
            productName: '圓滿人生終身壽險',
            allProductsName: ['圓滿人生終身壽險', '新住院醫療保險附約'],
            payerName: '林小磊',
            payerCode: '123123',
            insuredName: ['林小磊'],
            insuredCode: '123123',
            salesName: null,
            effectDate: '2013/03/01',
            createdDate: '2025-07-17 09:37:15.705',
            creatorName: '林小磊',
            remark: null,
            insType: null,
            sourceType: 3,
            updateDate: '2025-07-17 09:32:09'
        }
    ],
    queryInsuranceDetail: {
        insNo: '1234QWER567890',
        insCode: '1234QWER567890',
        productName: '圓滿人生終身壽險',
        insContent: [
            {
                productName: '圓滿人生終身壽險',
                productStatus: '有效',
                payerName: '林小磊',
                payerCode: 'test',
                insuredName: '林小磊',
                insuredCode: 'test',
                indemnityAmount: 1000000,
                insPeriod: '15年',
                effectDate: '2013-03-01',
                isInsPrimary: true
            },
            {
                productName: '新住院醫療保險附約',
                productStatus: '有效',
                payerName: '林小磊',
                payerCode: 'test',
                insuredName: '林小磊',
                insuredCode: 'test',
                indemnityAmount: 1000000,
                insPeriod: '15年',
                effectDate: '2013-03-01',
                isInsPrimary: false
            }
        ],
        fypDetail: {
            payType: '年繳',
            currency: '台幣',
            firstPayWay: '信用卡',
            nextPayWay: '信用卡',
            bank: '磊山銀行',
            creditCardNumber: '4000112211111111',
            creditCardValidThru: '08/31',
            totalFyp: 220998,
            nextPayDate: '2025-08-20'
        }
    },
    queryCustomInfo: {
        customerName: '林小磊',
        userId: 'A123456789',
        age: 18,
        birthday: '2007-11-29',
        insAge: 19,
        nextInsBirthday: '2026-11-29',
        mobile: '0912345678',
        address: '台北市中山區松江路87號2樓之2'
    },
    mutateInsurancePDF: {
        insurances: [
            {
                supplier: '磊山保經',
                ins_no: '1234QWER567890',
                pay_name: '林小磊',
                insurance_names: ['林小磊'],
                effect_date: '2013/03/01'
            },
            {
                supplier: '磊山保經',
                ins_no: '1234QWER567890-01',
                pay_name: '林小磊',
                insurance_names: ['林小磊'],
                effect_date: '2013/03/01'
            },
            {
                supplier: '磊山保經',
                ins_no: '1234QWER567890-02',
                pay_name: '林小磊',
                insurance_names: ['林小磊'],
                effect_date: '2013/03/01'
            }
        ],
        products: [
            {
                supplier: '磊山保經',
                pro_name: '圓滿人生終身壽險',
                isMain: '主約',
                // category_type: '人壽-一般',
                // isPaper: '紙本保單',
                amount: '17,099',
                effect_date: '2013/03/01',
                product_status: '有效',
                ins_no: '1234QWER567890',
                // category_name: '五動鑫富',
                insurance_name: '林小磊',
                pay_name: '林小磊',
                pay_period: '10年',
                period: '年繳'
                // insurance_type: '壽險'
            },
            {
                supplier: '磊山保經',
                pro_name: '圓滿人生終身壽險',
                isMain: '主約',
                // category_type: '人壽-一般',
                // isPaper: '紙本保單',
                amount: '17,099',
                effect_date: '2013/03/01',
                product_status: '有效',
                ins_no: '1234QWER567890-01',
                // category_name: '五動鑫富',
                insurance_name: '林小磊',
                pay_name: '林小磊',
                pay_period: '10年',
                period: '年繳'
                // insurance_type: '壽險'
            },
            {
                supplier: '磊山保經',
                pro_name: '圓滿人生終身壽險',
                isMain: '主約',
                // category_type: '人壽-一般',
                // isPaper: '紙本保單',
                amount: '17,099',
                effect_date: '2013/03/01',
                product_status: '有效',
                ins_no: '1234QWER567890-02',
                // category_name: '五動鑫富',
                insurance_name: '林小磊',
                pay_name: '林小磊',
                pay_period: '10年',
                period: '年繳'
                // insurance_type: '壽險'
            }
        ],
        errors: [],
        invalidData: {
            hasNoInsNoData: false
        }
    }
}
